// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group_container {
  height: 86vh;
}
.table-container {
  border-radius: 8px;
  border: 1px solid #d9e3d9;
  background-color: white;
  height: 380px;
  overflow: scroll;
}
.group_row {
  display: grid;
  grid-template-columns: 1fr 3fr 3fr 1fr;
}
.data-row,
.group_row {
  border-top: 1px solid #d9e3d9;
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .header-row,
  .data-row {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr;
    padding: 10px;
    height: 36px;
    font-size: 16px;
    text-align: center;
    justify-items: center;
  }
}

@media screen and (width: 1440px) {
  .header-row,
  .data-row {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr;
    /* padding: 10px; */
    height: 36px;
    font-size: 16px;
    text-align: center;
    justify-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GroupsSection/GroupsSection.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE;;IAEE,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":[".group_container {\n  height: 86vh;\n}\n.table-container {\n  border-radius: 8px;\n  border: 1px solid #d9e3d9;\n  background-color: white;\n  height: 380px;\n  overflow: scroll;\n}\n.group_row {\n  display: grid;\n  grid-template-columns: 1fr 3fr 3fr 1fr;\n}\n.data-row,\n.group_row {\n  border-top: 1px solid #d9e3d9;\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .header-row,\n  .data-row {\n    display: grid;\n    grid-template-columns: 2fr 2fr 2fr 2fr;\n    padding: 10px;\n    height: 36px;\n    font-size: 16px;\n    text-align: center;\n    justify-items: center;\n  }\n}\n\n@media screen and (width: 1440px) {\n  .header-row,\n  .data-row {\n    display: grid;\n    grid-template-columns: 2fr 2fr 2fr 2fr;\n    /* padding: 10px; */\n    height: 36px;\n    font-size: 16px;\n    text-align: center;\n    justify-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
